import { render, staticRenderFns } from "./SoloResults.vue?vue&type=template&id=38345e86&"
import script from "./SoloResults.vue?vue&type=script&lang=ts&"
export * from "./SoloResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports